import {Link as MuiLink, LinkProps} from "@mui/material";
import React, {ReactNode} from "react";
import {ITextProps} from "../../../ui";

type LinkType = Omit<LinkProps, "variant"> & {};

export interface ILink extends LinkType {
  size?: number;
  text?: string;
  bold?: boolean;
  onClick: (event: any) => void;
  href?: string;
  variant?: ITextProps["variant"];
  children?: ReactNode;
}

export interface ILinkHref extends ITextProps {
  text?: string;
  href?: string;
  color?: string;
}

export const Link = ({onClick, variant, href = "#", size = 16, children, sx}: ILink) => {
  return (
    <MuiLink
      onClick={onClick}
      href={href}
      className={"Link"}
      color="inherit"
      underline="always"
      /*
      // @ts-ignore */
      variant={variant}
      sx={{
        fontSize: `${size}px`,
        display: "inline",
        ...sx,
      }}
    >
      {children}
    </MuiLink>
  );
};

export const LinkHref = ({
  text,
  href,
  size = 16,
  color = "inherit",
  variant = "inter400",
  sx,
}: ILinkHref) => {
  return (
    <MuiLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      /*
        // @ts-ignore */
      variant={variant}
      className={"LinkHref"}
      sx={{
        textDecoration: "underline",
        display: "inline",
        cursor: "pointer",
        fontSize: `${size}px`,
        color,
        ...sx,
      }}
    >
      {text}
    </MuiLink>
  );
};
